<template>
  <v-card class="mx-auto" outlined>
    <v-card-text>
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <span class="ml-3">Cargando</span>
      </v-overlay>

      <v-card class="mt-4" outlined>
        <v-card-title class="headline">Detalle de cuenta</v-card-title>
        <v-card-text>
          <v-list two-line>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon left>mdi-package-variant</v-icon>
                  Cliente: {{ cuenta.clienteData.Nombres }}
                  {{ cuenta.clienteData.Apellidos }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon left>mdi-currency-usd</v-icon>
                  Monto:
                  {{
                    cuenta.Totales.MXN ? cuenta.Totales.MXN : cuenta.Totales.USD
                  }}
                  {{ cuenta.Totales.MXN ? "MXN" : "USD" }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>

      <v-btn color="green" dark class="mt-4" @click="exportExcel()">
        <v-icon left>mdi-file-excel-box</v-icon>
        Exportar a Excel
        <!-- <download-excel
          type="xls"
          :name="
            'Cuentas por cobrar ' +
            cuenta.clienteData.Nombres +
            ' ' +
            cuenta.clienteData.Apellidos
          "
          :data="dataExcel"
        >
      </download-excel> -->
      </v-btn>

      <v-simple-table class="mt-4">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Cantidad</th>
            <th>Cantidad MXN</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(agrupador, index) in calatalogo">
            <tr style="background: #80808024" :key="index">
              <td colspan="4">Fecha: {{ index }}</td>
            </tr>
            <template v-for="(prod, indexprod) in agrupador">
              <tr :key="indexprod + 'prod' + index">
                <td>{{ prod.Nombre }}</td>
                <td>{{ prod.Cnt }}</td>
                <td>
                  ${{ $pgsHelper.formatNumber(prod.Pco.C * prod.Cnt) }}
                  {{ prod.Pco.M }}
                </td>
                <td>{{ prod.fecha }}</td>
              </tr>
            </template>
          </template>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
//const $ = require('jquery');
//window.$ = $;
import moment from "moment";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel";

//import axiosCore from 'axios'

export default {
  name: "FormCuenta",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      cuenta: {
        clienteData: {},
        Totales: {},
      },
      Id: "",
      errors: {},
      loader: true,
    };
  },
  methods: {
    exportExcel() {
      const nombre =
        "Cuentas por cobrar " +
        this.cuenta.clienteData.Nombres +
        " " +
        this.cuenta.clienteData.Apellidos;

      GenericExcelExporter.generateExcelBuffer(this.dataExcel)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `${nombre}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => console.error("Error exportando Excel:", err));
    },
    getDateFormat(data) {
      return moment(data);
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.nombre) {
        this.errors.nombre = "El nombre del cupón es obligatorio";
        valid = false;
      } else {
        this.errors.nombre = false;
      }

      if (!this.mayorista) {
        this.errors.mayorista = "La agencia es obligatoria";
        valid = false;
      } else {
        this.errors.mayorista = false;
      }

      if (!this.cuponesIlimitados) {
        if (!this.cantidad) {
          this.errors.cantidad = "La cantidad de cupones es obligatoria";
          valid = false;
        } else {
          this.errors.cantidad = false;
        }
      }

      if (this.costoCupon.toString() == "") {
        this.$pgsHelper.log("invalido");
        this.errors.costoCupon = "el costo del cupón es obligatorio";
        valid = false;
      } else {
        this.$pgsHelper.log("valido");
        this.errors.costoCupon = false;
      }

      if (this.productos.length == 0) {
        this.errors.Producto = "Agregue al menos un producto";
        valid = false;
      } else {
        this.errors.Producto = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    calatalogo() {
      let agrupador = {};
      if (this.cuenta?.Catalogo) {
        this.cuenta.Catalogo.forEach((element) => {
          element.fecha = element.ExtraParams.CuentaData.Crat
            ? this.getDateFormat(element.ExtraParams.CuentaData.Crat).format(
                "YYYY-MM-DD HH:mm"
              )
            : "Otros";
        });
        this.cuenta.Catalogo.forEach((element) => {
          if (!agrupador[element.fecha]) {
            agrupador[element.fecha] = [];
          }
          agrupador[element.fecha].push(element);
        });
      }

      return agrupador;
    },
    dataExcel() {
      let data = [];
      if (this.cuenta?.Catalogo) {
        this.cuenta.Catalogo.forEach((element) => {
          element.fecha = element.ExtraParams.CuentaData.Crat
            ? this.getDateFormat(element.ExtraParams.CuentaData.Crat).format(
                "YYYY-MM-DD HH:mm"
              )
            : "Otros";
        });
        this.cuenta.Catalogo.forEach((element) => {
          data.push({
            Fecha: element.fecha,
            Nombre: element.Nombre,
            Cantidad: element.Cnt,
            Total: element.Cnt * element.Pco.C,
          });
        });
      }
      return data;
    },
  },
  watch: {},
  beforeMount: function () {
    this.loader = true;
  },
  mounted() {
    this.loader = false;

    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.cuenta = this.dataEdit;
    }
  },
};
</script>
